/* eslint-disable max-classes-per-file */
import { TranslateService } from "@ngx-translate/core";
import { Cellstyle, ClickableCell, HotCellText } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";

/* eslint-disable no-bitwise */
export class SettingsCell extends ClickableCell {

    constructor(flags?: Cellstyle, settings?: any, private readonly onHandle?: () => void) {
        super(flags, settings);
    }

    onClick = (hotDoc: HotDoc): void => {
        if (this.onHandle) {
            this.onHandle();
        }
    };

    protected genHtml(): string {
        return `<button class='btn btn-icon icon-btn accordion-trigger' type='button' ignore-readonly>` +
            `<i class="fas fa-cog"></i>` +
            `</button>`;
    }
}

export class BalansHeaderCell extends HotCellText {
    private readonly markup: string;

    constructor($translate: TranslateService, colSpan = 2) {
        super("", Cellstyle.Readonly | Cellstyle.AlignRight, { colSpan: colSpan });

        const text = $translate.instant("KUNDORDER_LEVRADER_HEADER_BALANS");
        const tooltip = $translate.instant("KUNDORDER_LEVRADER_HEADER_BALANS_TOOLTIP");
        this.markup = `${text} <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-placement="right" title="${tooltip}"></i>`;
    }

    protected genHtml(): string {
        return this.markup;
    }
}
